import { render } from "./EventBBPRetreatComponent.vue?vue&type=template&id=7520ed56&scoped=true&ts=true"
import script from "./EventBBPRetreatComponent.vue?vue&type=script&lang=ts"
export * from "./EventBBPRetreatComponent.vue?vue&type=script&lang=ts"

import "./EventBBPRetreatComponent.vue?vue&type=style&index=0&id=7520ed56&scoped=true&lang=scss"
import "./EventBBPRetreatComponent.vue?vue&type=style&index=1&id=7520ed56&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7520ed56"]])

export default __exports__